import { cx } from 'class-variance-authority';
import Icon from './Icon';

const Spinner: React.FC<Omit<React.ComponentProps<typeof Icon>, 'name'>> = props => (
    <Icon
        {...props}
        name="spinner"
        aria-label="Loading"
        className={cx('animate-spin text-blue-400', props.className)}
    />
);

export default Spinner;
